import type { ToastifyId } from "./types";

/**
 * The toast the Toaster is showing under `toastId`, or `undefined` if it is showing none. A
 * toast that was asked for is not necessarily on screen: the Toaster drops a repeat of a
 * `toastId` it already holds, and queues anything past its `limit` until a slot frees — which
 * three sticky danger toasts can hold up indefinitely.
 *
 * The id is compared rather than selected on, because react-toastify numbers the ids it generates
 * itself ("1", "2", ...) and `querySelector("#2")` throws on an invalid CSS identifier.
 */
export const findToastElement = (containerId: ToastifyId, toastId: ToastifyId): HTMLElement | undefined => {
  for (const toast of document.getElementById(String(containerId))?.querySelectorAll(".Toastify__toast") ?? []) {
    if (toast instanceof HTMLElement && toast.id === String(toastId)) {
      return toast;
    }
  }
  return undefined;
};
